/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from "react";
import { PopUp } from "../../../../atoms/PopUp";
import SpecifyVisitDurationPop from "./SpecifyVisitDurationPop";

import { createRoot, Root } from "react-dom/client";

const SpecifyVisitDurationPortal: React.FC<{
  tasks: any[];
  resolve: (value: { [taskId: string]: number } | null) => void;
  container: HTMLDivElement;
  root: Root;
}> = ({ tasks, resolve, container, root }) => {
  const [visible, setVisible] = useState(true);
  const [values, setValues] = useState<{ [taskId: string]: number }>({});

  const handleInputChange = (taskId: string, value: any) => {
    // const timeStr = value?.format("HH:mm");
    const timeStr = value;
    let decimalHours = 0;
    if (timeStr) {
      // const [h, m] = timeStr.split(":").map(Number);
      decimalHours = timeStr / 60;
      console.log(decimalHours); // 10.5
    }
    setValues((prev) => ({ ...prev, [taskId]: decimalHours }));
  };

  const cleanup = () => {
    root.unmount();
    document.body.removeChild(container);
  };

  const handleSubmit = () => {
    setVisible(false);
    resolve(values);
    setTimeout(cleanup, 300);
  };

  const handleCancel = () => {
    setVisible(false);
    resolve(null);
    setTimeout(cleanup, 300);
  };

  return (
    <PopUp
      visibility={visible}
      content={
        <SpecifyVisitDurationPop
          onClose={handleCancel}
          heading="Specify visit duration"
          paragraph="Scheduled time for time & material tickets must be entered manually."
          btnApi={handleSubmit}
          tasks={tasks}
          onChange={handleInputChange}
        />
      }
      width={380}
      onCancel={handleCancel}
    />
  );
};

const showSpecifyVisitDurationPopUp = (
  tasks: any[]
): Promise<{ [taskId: string]: number } | null> => {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = createRoot(container);
    root.render(
      <SpecifyVisitDurationPortal
        tasks={tasks}
        resolve={resolve}
        container={container}
        root={root}
      />
    );
  });
};

export default showSpecifyVisitDurationPopUp;
